import React from "react";
import { Box, Container, Typography, Grid, Button, Link } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";
import { useForm, FormContextInterface } from "../context";
import ProjectSoundDesigner from "../../assets/submit/project-sound-designer.jpg";
import RszProjectCartoon1 from "../../assets/submit/rsz_project-cartoon1.jpg";
import ProjectTvAdvert from "../../assets/submit/project-tv-advert.jpg";
import ProjectRetro from "../../assets/submit/project-retro.png";
import ProjectWinter from "../../assets/submit/project-winter.png";
import ProjectWildEarth from "../../assets/submit/project-wild-earth.jpg";
import logo from "../../assets/mtech-logo.png";

const Submitted = () => {
  const { studentInfo, schoolInfo, handleSubmitLogActivity } =
    useForm() as FormContextInterface;

  const handleWhatsAppClick = () => {
    handleSubmitLogActivity({
      ActivityType: "WhatsAppClick",
    });
  };

  var childPronouns = "";

  if (studentInfo.childPronouns == "1") {
    childPronouns = "he is";
  }
  if (studentInfo.childPronouns == "2") {
    childPronouns = "she is";
  }
  if (studentInfo.childPronouns == "3") {
    childPronouns = "they are";
  }
  if (studentInfo.childPronouns == "4") {
    if (studentInfo.other1 !== "") {
      childPronouns = studentInfo.other1 + " are";
    } else if (studentInfo.other2 !== "") {
      childPronouns = studentInfo.other2 + " are";
    } else if (studentInfo.other3 !== "") {
      childPronouns = studentInfo.other3 + " are";
    }
  }
  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Box display={"flex"} width="100%" justifyContent={"center"}>
        <Box
          display={"flex"}
          justifyContent="center"
          flexDirection={"column"}
          alignItems="center"
        >
          <img src={logo} width={"60%"} style={{ maxWidth: "400px" }} />
        </Box>
      </Box>

      <Typography
        marginBottom={3}
        style={{ marginTop: "28px", textAlign: "center" }}
      >
         Thank you for signing up {studentInfo.studentFirstName} to M:Tech at{" "}
        {schoolInfo.label}. We are delighted {childPronouns } inspired to join our course and start a new musical adventure.

      </Typography>

      <Box
        alignItems={"center"}
        justifyContent="center"
        display={"flex"}
        marginY={3}
        flexDirection="column"
      >
        <a href="https://api.whatsapp.com/send?text=https://mtechonline.co.uk" rel="nofollow noopener" target="_blank">
          <Button
            color="success"
            variant="contained"
            sx={{ color: "white" }}
            onClick={handleWhatsAppClick}
          >
            <WhatsApp />
            <Box component={"span"} paddingLeft={1} color="white">
              Share
            </Box>
          </Button>
        </a>
      </Box>
      <Box
        border={"1px solid"}
        borderColor="primary.main"
        width={"50%"}
        display="flex"
        margin={"auto"}
      ></Box>
      <Grid container marginY={3} spacing={1}>
        <Grid item xs={6} md={4}>
            <img src={ProjectWinter} width={"100%"} />
        </Grid>
        <Grid item xs={6} md={4}>
            <img src={ProjectRetro} width={"100%"} />
        </Grid>
        <Grid item xs={6} md={4}>
            <img src={RszProjectCartoon1} width={"100%"} />
        </Grid>
        <Grid item xs={6} md={4}>
            <img src={ProjectTvAdvert} width={"100%"} />
        </Grid>
        <Grid item xs={6} md={4}>
            <img src={ProjectWildEarth} width={"100%"} />
        </Grid>
        <Grid item xs={6} md={4}>
            <img src={ProjectSoundDesigner} width={"100%"} />
        </Grid>
      </Grid>

      <Box
        border={"1px solid"}
        borderColor="primary.main"
        width={"50%"}
        display="flex"
        margin={"auto"}
      ></Box>

      <Box
        alignItems={"center"}
        justifyContent="center"
        display={"flex"}
        marginY={3}
        flexDirection="column"
      >
        <Typography marginY={2} color="primary" variant="h5">
          <Link
            href="https://mtechonline.co.uk/"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            mtechonline.co.uk
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export { Submitted };
